import { useEntitlements } from "@/modules/useEntitlements";

/**
 * Panel operativo global — visible solo si el comprador tiene habilitado el módulo despacho.
 * Sin bloqueo ni error cuando no aplica.
 */
export function useDespachoPanelVisible() {
  const { loading, modulo_gestion_despacho, hasEntitlement, isPlatformDesigner } = useEntitlements();
  if (loading) return false;
  if (isPlatformDesigner) return true;
  return Boolean(modulo_gestion_despacho || hasEntitlement("despacho"));
}
